// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GZjAv","icon":"styles_icon__9c6aw","label":"styles_label__P9WB9","error":"styles_error__3u7UU","labelWrapper":"styles_labelWrapper___PUH_"};